import { JOB_LISTING_STATE } from '~/features/xstateSystem';
import { createListingStepMachine } from '../../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { OnCallShiftDetailsFormValues } from './types';

export const onCallShiftDetailsMachine = createListingStepMachine<OnCallShiftDetailsFormValues>(
  API_CALLS.patch,
  JOB_LISTING_STATE
);
